"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.buildAccount = void 0;
var logs_1 = require("@ledgerhq/logs");
var last_1 = __importDefault(require("lodash/last"));
var account_1 = require("../../account");
var buildBigNumber_1 = require("../buildBigNumber");
var buildOperation_1 = require("./buildOperation");
var buildSubAccounts_1 = require("./buildSubAccounts");
var reconciliation_1 = require("../../reconciliation");
var pagination_1 = require("../../pagination");
var getAccountBalanceHistory_1 = __importDefault(require("../getAccountBalanceHistory"));
var portfolio_1 = require("../../portfolio");
var libcore_mergeOperations_1 = __importDefault(require("../../generated/libcore-mergeOperations"));
var libcore_postBuildAccount_1 = __importDefault(require("../../generated/libcore-postBuildAccount"));
// FIXME how to get that
var OperationOrderKey = {
    date: 0
};
function queryOps(coreAccount) {
    return __awaiter(this, void 0, void 0, function () {
        var query;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, coreAccount.queryOperations()];
                case 1:
                    query = _a.sent();
                    return [4 /*yield*/, query.addOrder(OperationOrderKey.date, false)];
                case 2:
                    _a.sent();
                    return [2 /*return*/, query];
            }
        });
    });
}
function buildAccount(_a) {
    var core = _a.core, coreWallet = _a.coreWallet, coreAccount = _a.coreAccount, currency = _a.currency, accountIndex = _a.accountIndex, derivationMode = _a.derivationMode, seedIdentifier = _a.seedIdentifier, existingAccount = _a.existingAccount, logId = _a.logId, syncConfig = _a.syncConfig;
    return __awaiter(this, void 0, void 0, function () {
        var restoreKey, accountId, query, partialOperations, operationsPageSize, paginatedPartialOperations, nativeBalance, balance, coreAccountCreationInfo, derivations, accountPath, coreBlock, blockHeight, coreFreshAddresses, freshAddresses, name, subAccounts, inferCoreOperation, operations, lastOperation, coreOperation, balanceHistory, creationDate, swapHistory, account, f;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    (0, logs_1.log)("libcore", "sync(".concat(logId, ") start buildAccount"));
                    return [4 /*yield*/, coreAccount.getRestoreKey()];
                case 1:
                    restoreKey = _b.sent();
                    accountId = (0, account_1.encodeAccountId)({
                        type: "libcore",
                        version: "1",
                        currencyId: currency.id,
                        xpubOrAddress: restoreKey,
                        derivationMode: derivationMode
                    });
                    return [4 /*yield*/, queryOps(coreAccount)];
                case 2:
                    query = _b.sent();
                    return [4 /*yield*/, query.partial()];
                case 3:
                    _b.sent();
                    return [4 /*yield*/, query.execute()];
                case 4:
                    partialOperations = _b.sent();
                    operationsPageSize = (0, pagination_1.getOperationsPageSize)(accountId, syncConfig);
                    paginatedPartialOperations = isFinite(operationsPageSize)
                        ? partialOperations.slice(partialOperations.length - operationsPageSize)
                        : partialOperations;
                    (0, logs_1.log)("libcore", "sync(".concat(logId, ") DONE partial query ops"));
                    return [4 /*yield*/, coreAccount.getBalance()];
                case 5:
                    nativeBalance = _b.sent();
                    return [4 /*yield*/, (0, buildBigNumber_1.libcoreAmountToBigNumber)(nativeBalance)];
                case 6:
                    balance = _b.sent();
                    (0, logs_1.log)("libcore", "sync(".concat(logId, ") DONE balance"));
                    return [4 /*yield*/, coreWallet.getAccountCreationInfo(accountIndex)];
                case 7:
                    coreAccountCreationInfo = _b.sent();
                    return [4 /*yield*/, coreAccountCreationInfo.getDerivations()];
                case 8:
                    derivations = _b.sent();
                    accountPath = (0, last_1["default"])(derivations);
                    return [4 /*yield*/, coreAccount.getLastBlock()];
                case 9:
                    coreBlock = _b.sent();
                    return [4 /*yield*/, coreBlock.getHeight()];
                case 10:
                    blockHeight = _b.sent();
                    return [4 /*yield*/, coreAccount.getFreshPublicAddresses()];
                case 11:
                    coreFreshAddresses = _b.sent();
                    if (coreFreshAddresses.length === 0)
                        throw new Error("expected at least one fresh address");
                    return [4 /*yield*/, Promise.all(coreFreshAddresses.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                            var _a, address, path, derivationPath;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, Promise.all([
                                            item.toString(),
                                            item.getDerivationPath(),
                                        ])];
                                    case 1:
                                        _a = __read.apply(void 0, [_b.sent(), 2]), address = _a[0], path = _a[1];
                                        derivationPath = path
                                            ? "".concat(accountPath, "/").concat(path)
                                            : accountPath;
                                        return [2 /*return*/, {
                                                address: address,
                                                derivationPath: derivationPath
                                            }];
                                }
                            });
                        }); }))];
                case 12:
                    freshAddresses = _b.sent();
                    (0, logs_1.log)("libcore", "sync(".concat(logId, ") DONE coreAccount addresses"));
                    name = partialOperations.length === 0
                        ? (0, account_1.getNewAccountPlaceholderName)({
                            currency: currency,
                            index: accountIndex,
                            derivationMode: derivationMode
                        })
                        : (0, account_1.getAccountPlaceholderName)({
                            currency: currency,
                            index: accountIndex,
                            derivationMode: derivationMode
                        });
                    return [4 /*yield*/, (0, buildSubAccounts_1.buildSubAccounts)({
                            core: core,
                            currency: currency,
                            coreAccount: coreAccount,
                            accountId: accountId,
                            existingAccount: existingAccount,
                            logId: logId,
                            syncConfig: syncConfig
                        })];
                case 13:
                    subAccounts = _b.sent();
                    inferCoreOperation = function (corePartialOperation) { return __awaiter(_this, void 0, void 0, function () {
                        var query, _a, coreOperation;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0: return [4 /*yield*/, queryOps(coreAccount)];
                                case 1:
                                    query = _b.sent();
                                    return [4 /*yield*/, query.limit(1)];
                                case 2:
                                    _b.sent();
                                    return [4 /*yield*/, query.offset(partialOperations.indexOf(corePartialOperation))];
                                case 3:
                                    _b.sent();
                                    return [4 /*yield*/, query.complete()];
                                case 4:
                                    _b.sent();
                                    return [4 /*yield*/, query.execute()];
                                case 5:
                                    _a = __read.apply(void 0, [_b.sent(), 1]), coreOperation = _a[0];
                                    return [2 /*return*/, coreOperation];
                            }
                        });
                    }); };
                    return [4 /*yield*/, (0, reconciliation_1.minimalOperationsBuilder)((existingAccount && existingAccount.operations) || [], paginatedPartialOperations, function (corePartialOperation) { return __awaiter(_this, void 0, void 0, function () {
                            var _a;
                            var _b;
                            return __generator(this, function (_c) {
                                switch (_c.label) {
                                    case 0:
                                        _a = buildOperation_1.buildOperation;
                                        _b = {
                                            core: core
                                        };
                                        return [4 /*yield*/, inferCoreOperation(corePartialOperation)];
                                    case 1: return [2 /*return*/, _a.apply(void 0, [(_b.coreOperation = _c.sent(),
                                                _b.accountId = accountId,
                                                _b.currency = currency,
                                                _b.contextualSubAccounts = subAccounts,
                                                _b.existingAccount = existingAccount,
                                                _b)])];
                                }
                            });
                        }); }, libcore_mergeOperations_1["default"][currency.family])];
                case 14:
                    operations = _b.sent();
                    if (!(partialOperations.length > 0)) return [3 /*break*/, 18];
                    if (!(operations.length === partialOperations.length)) return [3 /*break*/, 15];
                    // we already have lastOperation
                    lastOperation = operations[operations.length - 1];
                    return [3 /*break*/, 18];
                case 15: return [4 /*yield*/, inferCoreOperation(partialOperations[0])];
                case 16:
                    coreOperation = _b.sent();
                    return [4 /*yield*/, (0, buildOperation_1.buildOperation)({
                            core: core,
                            coreOperation: coreOperation,
                            accountId: accountId,
                            currency: currency,
                            contextualSubAccounts: subAccounts,
                            existingAccount: existingAccount
                        })];
                case 17:
                    lastOperation = _b.sent();
                    _b.label = 18;
                case 18:
                    (0, logs_1.log)("libcore", "sync(".concat(logId, ") DONE operations"));
                    balanceHistory = {};
                    if (!!(0, account_1.libcoreNoGoBalanceHistory)().includes(currency.id)) return [3 /*break*/, 20];
                    return [4 /*yield*/, Promise.all((0, portfolio_1.getRanges)().map(function (range) { return __awaiter(_this, void 0, void 0, function () {
                            var h;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, (0, getAccountBalanceHistory_1["default"])(coreAccount, range)];
                                    case 1:
                                        h = _a.sent();
                                        if (!h[h.length - 1].value.isEqualTo(balance)) {
                                            (0, logs_1.log)("libcore", "last data point DOES NOT match the balance!");
                                            return [2 /*return*/];
                                        }
                                        balanceHistory[range] = h;
                                        return [2 /*return*/];
                                }
                            });
                        }); }))];
                case 19:
                    _b.sent();
                    _b.label = 20;
                case 20:
                    (0, logs_1.log)("libcore", "sync(".concat(logId, ") DONE balanceHistory"));
                    creationDate = new Date();
                    if (lastOperation) {
                        creationDate = lastOperation.date;
                    }
                    if (subAccounts) {
                        subAccounts.forEach(function (a) {
                            if (a.creationDate < creationDate) {
                                creationDate = a.creationDate;
                            }
                        });
                    }
                    swapHistory = (existingAccount === null || existingAccount === void 0 ? void 0 : existingAccount.swapHistory) || [];
                    account = {
                        type: "Account",
                        id: accountId,
                        seedIdentifier: seedIdentifier,
                        xpub: restoreKey,
                        derivationMode: derivationMode,
                        index: accountIndex,
                        freshAddress: freshAddresses[0].address,
                        freshAddressPath: freshAddresses[0].derivationPath,
                        freshAddresses: freshAddresses,
                        name: name,
                        starred: false,
                        used: false,
                        balance: balance,
                        balanceHistory: balanceHistory,
                        spendableBalance: balance,
                        blockHeight: blockHeight,
                        currency: currency,
                        unit: currency.units[0],
                        operationsCount: partialOperations.length,
                        operations: operations,
                        pendingOperations: [],
                        lastSyncDate: new Date(),
                        creationDate: creationDate,
                        swapHistory: swapHistory,
                        balanceHistoryCache: account_1.emptyHistoryCache
                    };
                    if (subAccounts) {
                        account.subAccounts = subAccounts;
                    }
                    account.used = !(0, account_1.isAccountEmpty)(account);
                    f = libcore_postBuildAccount_1["default"][currency.family];
                    if (!f) return [3 /*break*/, 22];
                    return [4 /*yield*/, f({
                            account: account,
                            coreAccount: coreAccount
                        })];
                case 21: return [2 /*return*/, _b.sent()];
                case 22: return [2 /*return*/, account];
            }
        });
    });
}
exports.buildAccount = buildAccount;
//# sourceMappingURL=index.js.map